var exports = {
  "T": "x234b8571--5f7894--map",
};

module.exports = exports;
